export const B2C_FAVICON_URL = 'https://www.datocms-assets.com/23873/1770736571-favicon.svg';
export const B2B_FAVICON_URL = 'https://www.datocms-assets.com/23873/1787136615-favicon.svg';

export type FaviconLinks = {
  appleTouchIcon: string;
  png32: string;
  svg: string;
};

export const getFavicon = (baseUrl: string): FaviconLinks => ({
  appleTouchIcon: `${baseUrl}?w=180&fm=png`,
  png32: `${baseUrl}?w=32&fm=png`,
  svg: baseUrl,
});
